import { Wrapper } from '@googlemaps/react-wrapper';

const GoogleMapsProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <Wrapper apiKey={import.meta.env.VITE_GOOGLE_MAPS_API_KEY!}>
      {children}
    </Wrapper>
  );
};

export default GoogleMapsProvider;
